import React, { useEffect } from 'react';
import { ChevronDown } from 'lucide-react';
import { useScrollIndicator } from '../useScrollIndicator';
import { useSegmentDefinitions } from '../useSegmentDefinitions';
import { StepDialogFooter } from '../StepDialogFooter';
import { SegmentListStates } from './SegmentListStates';
import { DATE_TRIGGER_STEP_COPY } from './date-trigger-step-copy';
import styles from './DateTriggerConfigDialog.module.css';

interface DateTriggerAudienceSelectionStepProps {
  selectedAudienceId: string;
  onSelect: (audienceId: string) => void;
  onBack: () => void;
  onCancel: () => void;
  onDone: () => void;
}

export const DateTriggerAudienceSelectionStep: React.FC<DateTriggerAudienceSelectionStepProps> = ({
  selectedAudienceId,
  onSelect,
  onBack,
  onCancel,
  onDone,
}) => {
  const { data: segmentDefinitions, isLoading, error } = useSegmentDefinitions();
  const { mainRef, hasMoreBelow, onScroll, checkScroll } = useScrollIndicator();

  useEffect(() => {
    checkScroll();
  }, [segmentDefinitions, checkScroll]);

  return (
    <>
      <div className={styles.mainWrapper}>
        <main ref={mainRef} onScroll={onScroll} className={styles.audienceList}>
          <p className={styles.audienceIntro}>{DATE_TRIGGER_STEP_COPY.audience.listIntro}</p>
          <SegmentListStates isLoading={isLoading} error={error} isEmpty={!segmentDefinitions?.length} />
          {segmentDefinitions && segmentDefinitions.length > 0 && (
            <ul>
              {segmentDefinitions.map(segment => {
                const { id, name, description, canonicalVersionId } = segment;
                const isSelected = selectedAudienceId === canonicalVersionId;
                return (
                  <li key={id}>
                    <button
                      type="button"
                      data-selected={isSelected || undefined}
                      onClick={() => onSelect(canonicalVersionId)}>
                      <strong>{name}</strong>
                      {description && <p>{description}</p>}
                    </button>
                  </li>
                );
              })}
            </ul>
          )}
        </main>
        {hasMoreBelow && (
          <div className={styles.scrollIndicator}>
            <span className={styles.scrollIndicatorPill}>
              <ChevronDown size={12} />
              More below
            </span>
          </div>
        )}
      </div>
      <StepDialogFooter
        onBack={onBack}
        onCancel={onCancel}
        onOK={onDone}
        okLabel={DATE_TRIGGER_STEP_COPY.audience.doneLabel}
      />
    </>
  );
};
